import { FooterAccordtion } from './FooterAccordtion'
import { withFooterAccordtion } from './withFooterAccordtion'

const ConnectedFooterAccordtion = withFooterAccordtion(FooterAccordtion)
export { ConnectedFooterAccordtion as FooterAccordtion }
